(function () {
    angular.module('app')
        .controller('CategoriesController', CategoriesController);

    CategoriesController.$inject = ['$scope', '$location'];
    function CategoriesController($scope, $location) {
        var ctrl = this;
        var previousValue = null;
        var query = $location.search();
        if (query.categories) {
            $scope.params.categories = parseInt(query.categories);
        }
        ctrl.clearCheck = function (value, group) {
            if (previousValue === value) {
                $scope.params[group] = null;
                previousValue = null;
            }
            else {
                previousValue = value;
            }
        }
    }
})();